import React from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import BarLoader from 'react-spinners/BarLoader';
import styled from 'styled-components';

const Warning = styled.span`
  margin: 0;
  padding: 0;
  color: #f50057;
  font-family: Roboto;
  font-weight: bold;
  font-size: 0.84rem;
  line-height: 1rem;
  text-align: center;
  letter-spacing: -0.04em;
`;

const AreYouSureYesNo = (props) => {
  const { onNo, onYes, loading, warning, loadingMessage } = props;
  if (loading) {
    return (
      <Grid container spacing={2} style={{ border: '1px solid #f5005790', background: '#f5005730', borderRadius: '4px', padding: '0 16px' }} alignItems="center">
        <Grid item xs={12}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <p style={{ margin: 0, paddingBottom: '20px', fontWeight: 'bold' }}>{loadingMessage}</p>
            <BarLoader height={4} width={100} color="#000000" loading={true} />
          </div>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container spacing={2} style={{ border: '1px solid #f5005790', background: '#f5005730', borderRadius: '4px', padding: 8 }} alignItems="center">
       <Grid item xs={12}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Warning>{warning}</Warning>
        </div>
       </Grid>
      <Grid item xs={6}>
        <div style={{ fontSize: '1rem' }}>Are you sure?</div>
      </Grid>
      <Grid item xs={6}>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button variant="contained" color="primary" onClick={onNo} style={{ marginRight: '16px' }}>
            NO
          </Button>
          <Button variant="contained" color="error" onClick={onYes}>
            YES
          </Button>
        </div>
      </Grid>
    </Grid>
  );
};

export default AreYouSureYesNo;
